import { useCallback, useMemo } from 'react';

import { INSTANT_SEARCH_INDEX_NAME_BASE, INSTANT_SEARCH_PRESET_BASE } from 'src/app/pages/search/shared/consts';
import { useLocale } from 'src/app/shared/hooks/l10n';
import { useTypesenseConfig } from 'src/app/shared/hooks/typesense';

type Result = ModelHookResult<{
	instantSearchIndexName: string;
	instantSearchPreset: string;
}>;

export function useInstantSearchIndexName(): Result {
	const locale = useLocale();
	const [language] = locale.split('-');

	const { namespace } = useTypesenseConfig();

	const addNamespace = useCallback(
		(indexName: string): string => {
			return namespace ? `${namespace}_${indexName}` : indexName;
		},
		[namespace],
	);

	return {
		data: {
			instantSearchIndexName: useMemo(() => {
				return addNamespace(`${INSTANT_SEARCH_INDEX_NAME_BASE}${language}`);
			}, [addNamespace, language]),
			instantSearchPreset: useMemo(() => {
				return addNamespace(`${INSTANT_SEARCH_PRESET_BASE}${language}`);
			}, [addNamespace, language]),
		},
	};
}
